
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import QrImage from "../../assets/image/parishram.jpg"

 function Donation(props) {
    
    return (
<>

    <div className="donationSection">
        <h3 className='sectionHeading'>Donate</h3>
        <span className='headingAfterLine'></span>
        <Row>
            <Col md={8}>
                <div className="accountInfoWrap">
                <div>
                    <h6>Donating to Parishrama Divyang sports academy Helps us transform the lives of athletes in Chasing their dreams. We pledge that 100% of Donations received will go directly towards funding our program like Training camps competitive Sporting events and equipment for the athlete</h6>
                <h6>Every contribution counts when it comes to supporting Differently-abled sports.Join us in making a difference and let’s create a more inclusive world through the Power of sports.We maintain a high degree of Integrity Transperency and accountability at the highest level at Utilisation and all donations to us are eligible for 50% tax exemption under section 80G of the Income tax.india</h6>
                <h6>When it comes to making a positive impact on the lives of children and handicapped individuals, donating to organizations dedicated to their well-being is a worthy endeavor.</h6>
                <h5>Parishrama divyang sports academy</h5>
                <ol>
                    <li><strong>Customer ID – </strong>6266955319</li>
                    <li><strong>Account No – </strong>10147433013</li>
                    <li><strong>IFSC CODE – </strong>IDFB0080185</li>
                    <li><strong>Branch name – </strong>JP nagar 7th phase</li>
                </ol>
                </div>
                </div>
            </Col>
            <Col md={4}>
                <div className="imgWrap">
                    <img src={QrImage} alt="donation-img" className='QrImage' />
                </div>
            </Col>
        </Row>
    </div>

</>

    )

}

export default Donation
